import * as tslib_1 from "tslib";
import selectConversationSortOrderOption from '../actions/selectConversationSortOrderOption';
import selectHideDeletedItemsOption from '../actions/selectHideDeletedItemsOption';
import selectGlobalListViewTypeOption from '../actions/selectGlobalListViewTypeOption';
import store from '../store/store';
import { ChoiceGroupWithImages } from 'owa-choice-group-with-images';
import { getFallbackValueIfNull } from 'owa-options-core';
import { getUserConfiguration } from 'owa-session-store';
import strings from 'owa-strings/owa-options-strings';
import * as React from 'react';
import { reactive } from 'satcheljs/lib/legacy/react';
import { ChoiceGroup } from 'office-ui-fabric-react/lib/ChoiceGroup';
var NEWEST_ON_TOP_SVG = require('./newestTopLarge.svg');
var NEWEST_ON_BOTTOM_SVG = require('./newestBottomLarge.svg');
var HIDE_DELETED_ITEMS_SVG = require('./hideDeletedLarge.svg');
var SHOW_DELETED_ITEMS_SVG = require('./showDeletedLarge.svg');
var ConversationsFull = /** @class */ (function (_super) {
    tslib_1.__extends(ConversationsFull, _super);
    function ConversationsFull() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onListViewTypeChange = function (ev, option) {
            selectGlobalListViewTypeOption(+option.key);
        };
        _this.onHideDeletedItemsChanged = function (ev, option) {
            selectHideDeletedItemsOption(option.key === 'true');
        };
        _this.onChangeSortOrder = function (ev, option) {
            selectConversationSortOrderOption(option.key);
        };
        return _this;
    }
    ConversationsFull.prototype.render = function () {
        var _a = this.props, userOptions = _a.userOptions, optionState = _a.optionState;
        var listViewTypeSelectedKey = getFallbackValueIfNull(optionState.globalListViewType, userOptions.GlobalListViewTypeReact);
        var conversationSortOrderKey = optionState.conversationSortOrder || userOptions.ConversationSortOrderReact;
        var hideDeletedItemsKey = "" + getFallbackValueIfNull(optionState.hideDeletedItems, userOptions.HideDeletedItems);
        return (React.createElement("div", null,
            React.createElement(ChoiceGroup, { selectedKey: "" + listViewTypeSelectedKey, label: strings.options_messageOrganization_positionLabel, options: [
                    {
                        key: "" + 0 /* Conversation */,
                        text: strings.options_messageOrganization_showAsConversation,
                    },
                    {
                        key: "" + 1 /* Message */,
                        text: strings.options_messageOrganization_showAsMessage,
                    },
                ], onChange: this.onListViewTypeChange }),
            listViewTypeSelectedKey === 0 /* Conversation */ && [
                React.createElement(ChoiceGroupWithImages, { key: "sortOrder", selectedKey: conversationSortOrderKey, label: strings.options_conversations_sortOrderLabel, options: [
                        {
                            key: 'ChronologicalNewestOnTop',
                            text: strings.options_conversations_sortOrderTop,
                            imageUri: NEWEST_ON_TOP_SVG,
                            width: 280,
                        },
                        {
                            key: 'ChronologicalNewestOnBottom',
                            text: strings.options_conversations_sortOrderBottom,
                            imageUri: NEWEST_ON_BOTTOM_SVG,
                            width: 280,
                        },
                    ], onChange: this.onChangeSortOrder }),
                React.createElement(ChoiceGroupWithImages, { key: "deletedItems", selectedKey: hideDeletedItemsKey, label: strings.options_conversations_deletedItemsLabel, options: [
                        {
                            key: 'false',
                            text: strings.options_conversations_deletedItemsShow,
                            imageUri: SHOW_DELETED_ITEMS_SVG,
                            width: 280,
                        },
                        {
                            key: 'true',
                            text: strings.options_conversations_deletedItemsHide,
                            imageUri: HIDE_DELETED_ITEMS_SVG,
                            width: 280,
                        },
                    ], onChange: this.onHideDeletedItemsChanged }),
            ]));
    };
    ConversationsFull = tslib_1.__decorate([
        reactive({
            userOptions: function () { return getUserConfiguration().UserOptions; },
            optionState: function () { return store; },
        })
    ], ConversationsFull);
    return ConversationsFull;
}(React.Component));
export default ConversationsFull;
//# sourceMappingURL=ConversationsFull.js.map